import { Controller, useForm } from "react-hook-form";
import Icon from "../icons";
import Button from "../elements/button";
import { Dropdown, Menu } from "../Dropdown";
import { filterConfigType } from "../../_config/types";
import { useEffect, useState } from "react";
import Label from "../elements/form/fromLabel";
import SelectBox from "../elements/form/selectBox";
import Input from "../elements/form/input";
import Datepicker from "../elements/form/datepicker";
import { getSelectedOptions } from "../../_common/functions";
import moment from "moment";
import { DATE_FORMAT } from "../../_common/constant";

interface Props {
  _ref: React.RefObject<HTMLDialogElement>;
  config: filterConfigType[];
  filters: any;
  onUpdate?: (filters: any) => void;
}

const Filters: React.FC<Props> = ({
  _ref,
  config,
  filters,
  onUpdate = () => { },
}) => {
  const [appliedFilters, setAppliedFilters] = useState<filterConfigType[]>([]);
  const [appliedFiltersData, setAppliedFiltersData] = useState<any>(null);
  const {
    control,
    register,
    getValues,
    unregister,
    reset,
    handleSubmit,
    setValue,
    resetField,
    formState: { errors },
  } = useForm<any>();

  const onSubmit = (formData: any) => {
    let newFilters: any = {};
    appliedFilters.forEach((filter: filterConfigType) => {
      // Skip if the form data value is null, undefined, or empty
      if (!formData[filter.key] || (Array.isArray(formData[filter.key]) && formData[filter.key].length === 0)) {
        return;
      }
      
      if (filter.type == "dropdown") {
        if (filter.isMulti === false) {
          newFilters[filter.key] = formData[filter.key]?.value;
        } else {
          newFilters[filter.key] = formData[filter.key]
            ?.map((option: any) => option?.value)
            .join(",");
        }
      } else {
        if (filter.type == "date-range" && filter.key.split(",").length > 1) {
          let keys = filter.key.split(",");
          newFilters[keys[0]] = moment(formData[filter.key][0]).format('YYYY-MM-DD');
          newFilters[keys[1]] = moment(formData[filter.key][1]).format('YYYY-MM-DD');
        } else if (filter.type == "date") {
          // Format single date to prevent timezone issues
          newFilters[filter.key] = moment(formData[filter.key]).format('YYYY-MM-DD');
        } else {
          newFilters[filter.key] = formData[filter.key];
        }
      }
    });
    setAppliedFiltersData(formData)
    // Merge with existing filters to preserve facilityIDs and other external filters
    onUpdate({ ...filters, ...newFilters });
    _ref?.current?.close();
  };

  const onClose = () => {
    _ref?.current?.close();
  };

  const addFilter = (filter: filterConfigType) => {
    setAppliedFilters((prevFilters) => [...prevFilters, filter]);
    // setAppliedFilters([...appliedFilters, filter]);
  };

  const removeFilter = (filter: filterConfigType) => {
    setValue(filter.key, null);
    
    // Remove from appliedFilters list
    const updatedAppliedFilters = appliedFilters.filter(
      (_filter: filterConfigType) => _filter.name != filter.name
    );
    setAppliedFilters(updatedAppliedFilters);
    
    unregister(filter.key);
    
    // Update appliedFiltersData to remove the deleted filter
    if (appliedFiltersData) {
      const updatedAppliedFiltersData = { ...appliedFiltersData };
      delete updatedAppliedFiltersData[filter.key];
      setAppliedFiltersData(updatedAppliedFiltersData);
    }
    
    // Update parent filters immediately to remove the deleted filter
    const updatedFilters = { ...filters };
    
    // Handle date-range filters that use multiple keys
    if (filter.type === "date-range" && filter.key.includes(",")) {
      const keys = filter.key.split(",");
      keys.forEach(key => delete updatedFilters[key]);
    } else {
      delete updatedFilters[filter.key];
    }
    
    onUpdate(updatedFilters);
  };

  useEffect(() => {
    
    let appliedFilters: filterConfigType[] = [];
    Object.keys(filters).forEach((key: string) => {
      let filter: filterConfigType = config.filter(
        (_filter: filterConfigType) => _filter.key == key
      )[0];
      if (filter) {
        appliedFilters.push(filter);
      } else {
        let keys: any = config.map((f: filterConfigType) => f.key);
        let matchedKey = keys.find((k: string) => k.startsWith(key));
        if( matchedKey ) {
          filter = config.filter(
            (_filter: filterConfigType) => _filter.key == matchedKey
          )[0];
          if (filter) {
            appliedFilters.push(filter);
          }
        }
      }
    });

    setAppliedFilters(appliedFilters);

    if (appliedFilters.length == 0) {
      Object.keys(getValues()).forEach((key: string) => {
        unregister(key);
      });
    }
    let resetValues: any = {};
    Object.keys(filters).forEach((key: string) => {
      let filter: filterConfigType = config.filter(
        (_filter: filterConfigType) => _filter.key == key
      )[0];
      if (filter?.type == "dropdown") {
        if (filter.isMulti === false) {
          if (filter.async && appliedFiltersData && appliedFiltersData[key]) {
            resetValues[key] = appliedFiltersData[key]
          } else if (filter.options) {
            resetValues[key] = filter.options?.filter(
              (option: any) => option.value == filters[key]
            )[0];
          }
        } else {
          if (filter.async && appliedFiltersData && appliedFiltersData[key]) {
            resetValues[key] = appliedFiltersData[key];
          } else if (filter.options) {
            resetValues[key] = getSelectedOptions(
              filters[key]?.split(","),
              filter.options as any
            );
          }
        }
      } else {
        if(filter){
          resetValues[key] = filters[key];
        } else {
          let keys: any = config.map((f: filterConfigType) => f.key);
          let matchedKey = keys.find((k: string) => k.startsWith(key));
          if (matchedKey) {
            resetValues[matchedKey] = matchedKey.split(",").map((k: string) => {
              return moment(filters[k]).toDate();
            });
          }
        }


        
      }
    });
    console.log('~~~~~~~~~~~~~~~~',filters, appliedFiltersData, resetValues);
    reset(resetValues);
  }, [filters]);

  useEffect(() => {
    const handleKeyPress = (event: KeyboardEvent) => {
      if (event.key === "Enter") {
        event.preventDefault();
        event.stopPropagation();
        handleSubmit(onSubmit)();
      }
    };
    document.addEventListener("keypress", handleKeyPress);

    return () => {
      document.removeEventListener("keypress", handleKeyPress);
    };
  }, [appliedFilters]);

  return (
    <dialog ref={_ref} className="modal">
      <div className="modal-box max-w-[90%] w-[38rem]  min-h-[30rem] p-4">
        <form onSubmit={handleSubmit(onSubmit)}>
          <div className="flex items-center justify-between border-b border-[#dddcdc] pb-2 mb-2">
            <p className="text-[1.063rem] text-[#755B51] font-semibold">
              Filters
            </p>
            <button
              type="button"
              onClick={onClose}
              className="bg-primary text-white p-1 rounded-md"
            >
              <Icon name="close" size={1.25} />
            </button>
          </div>

          <div className="py-3 min-h-[22rem]">
            {appliedFilters?.map((filter: filterConfigType, i: number) => (
              <div key={`applied-facility-filter-${i}`}>
                <div className="flex items-center justify-between mb-2">
                  <Label text={filter.name} />
                  <Icon
                    name="delete"
                    className="text-gray-300 hover:text-red-500"
                    onClick={() => {
                      removeFilter(filter);
                    }}
                  />
                </div>

                <Controller
                  name={filter.key}
                  control={control}
                  render={({ field: { value, onChange } }) => {
                    switch (filter.type) {
                      case "text":
                        return (
                          <Input
                            type="text"
                            value={value}
                            onChange={onChange}
                          />
                        );
                      case "dropdown":
                        if (filter.async) {
                          return (
                            <SelectBox
                              async={true}
                              value={value}
                              onChange={onChange}
                              menuPlacement={i > 0 ? "top" : "auto"}
                              asyncLoadOptions={filter.async as any}
                              isMulti={filter.isMulti === false ? false : true}
                              isClearable={true}
                              placeholder="Type to search"
                            />
                          );
                        } else {
                          return (
                            <SelectBox
                              value={value}
                              onChange={onChange}
                              menuPlacement={i > 0 ? "top" : "auto"}
                              options={
                                filter.options ? (filter.options as any) : []
                              }
                              isMulti={filter.isMulti === false ? false : true}
                              isClearable={true}
                            />
                          );
                        }
                      case "date":
                        return <Datepicker value={value} onChange={onChange} />;
                      case "date-range":
                        return (
                          <Datepicker
                            type={"range"}
                            value={value}
                            onChange={onChange}
                          />
                        );
                      case "number":
                        return (
                          <Input
                            type="number"
                            value={value}
                            onChange={onChange}
                          />
                        );
                      default:
                        return (
                          <Input
                            type="text"
                            value={value}
                            onChange={onChange}
                          />
                        );
                    }
                  }}
                />
              </div>
            ))}
          </div>

          <div className="flex justify-between gap-2 border-t border-[#dddcdc] pt-2">
            <div>
              <Dropdown position="top">
                <Dropdown.Button>
                  <Button size="sm" theme="secondary" type="button">
                    <Icon name="add-filter" size={1} />
                    Add Filter
                  </Button>
                </Dropdown.Button>
                <Dropdown.Content
                  title="Create New Facility"
                  className="!w-[39.563rem]"
                >
                  {config?.map((filter: filterConfigType, i: number) => {
                    const applied: boolean =
                      appliedFilters.filter(
                        (_filter: filterConfigType) =>
                          _filter.name == filter.name
                      ).length > 0;
                    if (applied) {
                      return null;
                    }
                    return (
                      <Menu
                        key={`facility-filter-menu-${i}`}
                        onClick={() => {
                          addFilter(filter);
                        }}
                      >
                        {filter.name}
                      </Menu>
                    );
                  })}
                </Dropdown.Content>
              </Dropdown>
            </div>
            <div className="flex gap-2 items-center">
              <Button type="button" size="sm" theme="light" onClick={onClose}>
                Cancel
              </Button>
              <Button size="sm" type="submit">
                Apply Filter
              </Button>
            </div>
          </div>
        </form>
      </div>
      <form method="dialog" className="modal-backdrop" onClick={onClose}></form>
    </dialog>
  );
};

export default Filters;
